import { render } from "./DomainBlocksStatBar.vue?vue&type=template&id=3b8aa136&scoped=true"
import script from "./DomainBlocksStatBar.vue?vue&type=script&lang=js"
export * from "./DomainBlocksStatBar.vue?vue&type=script&lang=js"

import "./DomainBlocksStatBar.vue?vue&type=style&index=0&id=3b8aa136&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8aa136"]])

export default __exports__